<template>
  <cargo-advance-select
    ref="cargoAdvanceSelect"
    v-bind="$attrs"
    :select-type="selectType"
    :method-params="methodParams"
    :cache="cache"
    :default-value="defaultValue"
    v-on="$listeners"
  />
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { basicDataCacheKeyPrefix } from '@/utils/cacheConfig'
import { getObjectByCache } from '@/utils/basicDataCache'

export default {
  name: 'CargoCacheAdvanceSelect',
  components: { cargoAdvanceSelect },
  props: {
    selectType: { type: String, default: '' },
    methodParams: { type: Object, default: () => { return {} } },
    cache: { type: Boolean, default: true },
    defaultValue: { type: [String, Number, Boolean], default: '' }
  },
  watch: {
    selectType: {
      immediate: true,
      handler() {
        this.matchDefaultValue()
      }
    },
    methodParams() {
      this.matchDefaultValue()
    },
    cache() {
      this.matchDefaultValue()
    },
    defaultValue() {
      this.matchDefaultValue()
    }
  },
  methods: {
    matchDefaultValue() {
      if (!this.selectType.startsWith(basicDataCacheKeyPrefix) || !this.cache || this.defaultValue === '') {
        return
      }
      this.$nextTick(() => {
        const options = this.$refs.cargoAdvanceSelect.options
        const tagValue = this.$refs.cargoAdvanceSelect.tagValue
        let defaultOption = options.find(p => p[tagValue] === this.defaultValue)
        if (!defaultOption) {
          defaultOption = getObjectByCache(this.selectType, tagValue, this.defaultValue)
          if (defaultOption) {
            options.push(defaultOption)
          }
        }
      })
    }
  }
}
</script>
